import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\SMS\CampaignController::index
* @see app/Http/Controllers/SMS/CampaignController.php:53
* @route '/sms/campaigns'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/sms/campaigns',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SMS\CampaignController::index
* @see app/Http/Controllers/SMS/CampaignController.php:53
* @route '/sms/campaigns'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SMS\CampaignController::index
* @see app/Http/Controllers/SMS/CampaignController.php:53
* @route '/sms/campaigns'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::index
* @see app/Http/Controllers/SMS/CampaignController.php:53
* @route '/sms/campaigns'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::index
* @see app/Http/Controllers/SMS/CampaignController.php:53
* @route '/sms/campaigns'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::index
* @see app/Http/Controllers/SMS/CampaignController.php:53
* @route '/sms/campaigns'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::index
* @see app/Http/Controllers/SMS/CampaignController.php:53
* @route '/sms/campaigns'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\SMS\CampaignController::create
* @see app/Http/Controllers/SMS/CampaignController.php:103
* @route '/sms/campaigns/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/sms/campaigns/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SMS\CampaignController::create
* @see app/Http/Controllers/SMS/CampaignController.php:103
* @route '/sms/campaigns/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SMS\CampaignController::create
* @see app/Http/Controllers/SMS/CampaignController.php:103
* @route '/sms/campaigns/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::create
* @see app/Http/Controllers/SMS/CampaignController.php:103
* @route '/sms/campaigns/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::create
* @see app/Http/Controllers/SMS/CampaignController.php:103
* @route '/sms/campaigns/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::create
* @see app/Http/Controllers/SMS/CampaignController.php:103
* @route '/sms/campaigns/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::create
* @see app/Http/Controllers/SMS/CampaignController.php:103
* @route '/sms/campaigns/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\SMS\CampaignController::store
* @see app/Http/Controllers/SMS/CampaignController.php:131
* @route '/sms/campaigns'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/sms/campaigns',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SMS\CampaignController::store
* @see app/Http/Controllers/SMS/CampaignController.php:131
* @route '/sms/campaigns'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SMS\CampaignController::store
* @see app/Http/Controllers/SMS/CampaignController.php:131
* @route '/sms/campaigns'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::store
* @see app/Http/Controllers/SMS/CampaignController.php:131
* @route '/sms/campaigns'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::store
* @see app/Http/Controllers/SMS/CampaignController.php:131
* @route '/sms/campaigns'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\SMS\CampaignController::show
* @see app/Http/Controllers/SMS/CampaignController.php:79
* @route '/sms/campaigns/{campaign}'
*/
export const show = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/sms/campaigns/{campaign}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SMS\CampaignController::show
* @see app/Http/Controllers/SMS/CampaignController.php:79
* @route '/sms/campaigns/{campaign}'
*/
show.url = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { campaign: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.id
        : args.campaign,
    }

    return show.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SMS\CampaignController::show
* @see app/Http/Controllers/SMS/CampaignController.php:79
* @route '/sms/campaigns/{campaign}'
*/
show.get = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::show
* @see app/Http/Controllers/SMS/CampaignController.php:79
* @route '/sms/campaigns/{campaign}'
*/
show.head = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::show
* @see app/Http/Controllers/SMS/CampaignController.php:79
* @route '/sms/campaigns/{campaign}'
*/
const showForm = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::show
* @see app/Http/Controllers/SMS/CampaignController.php:79
* @route '/sms/campaigns/{campaign}'
*/
showForm.get = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::show
* @see app/Http/Controllers/SMS/CampaignController.php:79
* @route '/sms/campaigns/{campaign}'
*/
showForm.head = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\SMS\CampaignController::schedule
* @see app/Http/Controllers/SMS/CampaignController.php:211
* @route '/sms/campaigns/{campaign}/schedule'
*/
export const schedule = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: schedule.url(args, options),
    method: 'post',
})

schedule.definition = {
    methods: ["post"],
    url: '/sms/campaigns/{campaign}/schedule',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SMS\CampaignController::schedule
* @see app/Http/Controllers/SMS/CampaignController.php:211
* @route '/sms/campaigns/{campaign}/schedule'
*/
schedule.url = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { campaign: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.id
        : args.campaign,
    }

    return schedule.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SMS\CampaignController::schedule
* @see app/Http/Controllers/SMS/CampaignController.php:211
* @route '/sms/campaigns/{campaign}/schedule'
*/
schedule.post = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: schedule.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::schedule
* @see app/Http/Controllers/SMS/CampaignController.php:211
* @route '/sms/campaigns/{campaign}/schedule'
*/
const scheduleForm = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: schedule.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::schedule
* @see app/Http/Controllers/SMS/CampaignController.php:211
* @route '/sms/campaigns/{campaign}/schedule'
*/
scheduleForm.post = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: schedule.url(args, options),
    method: 'post',
})

schedule.form = scheduleForm

/**
* @see \App\Http\Controllers\SMS\CampaignController::pause
* @see app/Http/Controllers/SMS/CampaignController.php:237
* @route '/sms/campaigns/{campaign}/pause'
*/
export const pause = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pause.url(args, options),
    method: 'post',
})

pause.definition = {
    methods: ["post"],
    url: '/sms/campaigns/{campaign}/pause',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SMS\CampaignController::pause
* @see app/Http/Controllers/SMS/CampaignController.php:237
* @route '/sms/campaigns/{campaign}/pause'
*/
pause.url = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { campaign: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.id
        : args.campaign,
    }

    return pause.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SMS\CampaignController::pause
* @see app/Http/Controllers/SMS/CampaignController.php:237
* @route '/sms/campaigns/{campaign}/pause'
*/
pause.post = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pause.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::pause
* @see app/Http/Controllers/SMS/CampaignController.php:237
* @route '/sms/campaigns/{campaign}/pause'
*/
const pauseForm = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pause.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::pause
* @see app/Http/Controllers/SMS/CampaignController.php:237
* @route '/sms/campaigns/{campaign}/pause'
*/
pauseForm.post = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pause.url(args, options),
    method: 'post',
})

pause.form = pauseForm

/**
* @see \App\Http\Controllers\SMS\CampaignController::resume
* @see app/Http/Controllers/SMS/CampaignController.php:255
* @route '/sms/campaigns/{campaign}/resume'
*/
export const resume = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resume.url(args, options),
    method: 'post',
})

resume.definition = {
    methods: ["post"],
    url: '/sms/campaigns/{campaign}/resume',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SMS\CampaignController::resume
* @see app/Http/Controllers/SMS/CampaignController.php:255
* @route '/sms/campaigns/{campaign}/resume'
*/
resume.url = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { campaign: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.id
        : args.campaign,
    }

    return resume.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SMS\CampaignController::resume
* @see app/Http/Controllers/SMS/CampaignController.php:255
* @route '/sms/campaigns/{campaign}/resume'
*/
resume.post = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resume.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::resume
* @see app/Http/Controllers/SMS/CampaignController.php:255
* @route '/sms/campaigns/{campaign}/resume'
*/
const resumeForm = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resume.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::resume
* @see app/Http/Controllers/SMS/CampaignController.php:255
* @route '/sms/campaigns/{campaign}/resume'
*/
resumeForm.post = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resume.url(args, options),
    method: 'post',
})

resume.form = resumeForm

/**
* @see \App\Http\Controllers\SMS\CampaignController::cancel
* @see app/Http/Controllers/SMS/CampaignController.php:273
* @route '/sms/campaigns/{campaign}/cancel'
*/
export const cancel = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancel.url(args, options),
    method: 'post',
})

cancel.definition = {
    methods: ["post"],
    url: '/sms/campaigns/{campaign}/cancel',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SMS\CampaignController::cancel
* @see app/Http/Controllers/SMS/CampaignController.php:273
* @route '/sms/campaigns/{campaign}/cancel'
*/
cancel.url = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { campaign: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.id
        : args.campaign,
    }

    return cancel.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SMS\CampaignController::cancel
* @see app/Http/Controllers/SMS/CampaignController.php:273
* @route '/sms/campaigns/{campaign}/cancel'
*/
cancel.post = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancel.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::cancel
* @see app/Http/Controllers/SMS/CampaignController.php:273
* @route '/sms/campaigns/{campaign}/cancel'
*/
const cancelForm = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::cancel
* @see app/Http/Controllers/SMS/CampaignController.php:273
* @route '/sms/campaigns/{campaign}/cancel'
*/
cancelForm.post = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(args, options),
    method: 'post',
})

cancel.form = cancelForm

/**
* @see \App\Http\Controllers\SMS\CampaignController::metrics
* @see app/Http/Controllers/SMS/CampaignController.php:311
* @route '/sms/campaigns/{campaign}/metrics'
*/
export const metrics = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: metrics.url(args, options),
    method: 'get',
})

metrics.definition = {
    methods: ["get","head"],
    url: '/sms/campaigns/{campaign}/metrics',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SMS\CampaignController::metrics
* @see app/Http/Controllers/SMS/CampaignController.php:311
* @route '/sms/campaigns/{campaign}/metrics'
*/
metrics.url = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { campaign: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { campaign: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            campaign: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        campaign: typeof args.campaign === 'object'
        ? args.campaign.id
        : args.campaign,
    }

    return metrics.definition.url
            .replace('{campaign}', parsedArgs.campaign.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SMS\CampaignController::metrics
* @see app/Http/Controllers/SMS/CampaignController.php:311
* @route '/sms/campaigns/{campaign}/metrics'
*/
metrics.get = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: metrics.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::metrics
* @see app/Http/Controllers/SMS/CampaignController.php:311
* @route '/sms/campaigns/{campaign}/metrics'
*/
metrics.head = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: metrics.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::metrics
* @see app/Http/Controllers/SMS/CampaignController.php:311
* @route '/sms/campaigns/{campaign}/metrics'
*/
const metricsForm = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: metrics.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::metrics
* @see app/Http/Controllers/SMS/CampaignController.php:311
* @route '/sms/campaigns/{campaign}/metrics'
*/
metricsForm.get = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: metrics.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::metrics
* @see app/Http/Controllers/SMS/CampaignController.php:311
* @route '/sms/campaigns/{campaign}/metrics'
*/
metricsForm.head = (args: { campaign: string | number | { id: string | number } } | [campaign: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: metrics.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

metrics.form = metricsForm

/**
* @see \App\Http\Controllers\SMS\CampaignController::preview
* @see app/Http/Controllers/SMS/CampaignController.php:293
* @route '/sms/campaigns/preview'
*/
export const preview = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: preview.url(options),
    method: 'post',
})

preview.definition = {
    methods: ["post"],
    url: '/sms/campaigns/preview',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SMS\CampaignController::preview
* @see app/Http/Controllers/SMS/CampaignController.php:293
* @route '/sms/campaigns/preview'
*/
preview.url = (options?: RouteQueryOptions) => {
    return preview.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SMS\CampaignController::preview
* @see app/Http/Controllers/SMS/CampaignController.php:293
* @route '/sms/campaigns/preview'
*/
preview.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: preview.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::preview
* @see app/Http/Controllers/SMS/CampaignController.php:293
* @route '/sms/campaigns/preview'
*/
const previewForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: preview.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SMS\CampaignController::preview
* @see app/Http/Controllers/SMS/CampaignController.php:293
* @route '/sms/campaigns/preview'
*/
previewForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: preview.url(options),
    method: 'post',
})

preview.form = previewForm

const campaigns = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    schedule: Object.assign(schedule, schedule),
    pause: Object.assign(pause, pause),
    resume: Object.assign(resume, resume),
    cancel: Object.assign(cancel, cancel),
    metrics: Object.assign(metrics, metrics),
    preview: Object.assign(preview, preview),
}

export default campaigns